export const BEACONSTAC_HOSTS: Array<any> = [
    'dashboard.beaconstac.com',
    'dashboard.uniqode.com',
    'bac-prod.firebaseapp.com',
    'bac-qa.firebaseapp.com',
    'dashboardqa.beaconstac.com',
    'localhost',
    'amplifyapp.com',
    'mycards.uniqode.com',
    'staging.mycards.uniqode.com',
];

export const BEACONSTAC_ADMIN = 'admin.uniqode.com';

export const IMAGE_SUMMARIZE_ENDPOINT = 'image-summarize/';

// PTR - Pull To Refresh
export const NON_PTR_PATH_FRAGMENT = [
    'lead_list',
    'capture',
];

export enum DBC_SCREENS {
    CARDS = '',
    LIST = 'list',
    SHARE = 'share',
    CAPTURE = 'capture',
    LEAD_LIST = 'lead_list',
}

export const LEAD_FILENAME_PREFIX = 'Lead-asset-';


export const FIRST_NAME_MAX_LENGTH = 128;
export const LAST_NAME_MAX_LENGTH = 128;
export const EMAIL_MAX_LENGTH = 254;
export const COMPANY_MAX_LENGTH = 128;
export const PHONE_MAX_LENGTH = 30;
export const DESIGNATION_MAX_LENGTH = 128;
